<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'

import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()
</script>

<template>
  <NuxtLoadingIndicator color="var(--ui-primary)" :height="2" />
  <UApp :locale="fr" :tooltip="{ delayDuration: 0}">
    <UError :error="error" />
  </UApp>
</template>